"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dynamic import function for components

var styleItem = {
  flex: "1 0 30%",
  width: "33.33%",
  marginRight: "6px",
  marginLeft: "6px"
};

var ServiceMasterSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/ServiceMaster").then(function (module) {
    return module.default;
  });
});

var ServiceMasterAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/ServiceMaster/ServiceMasterAdd").then(function (module) {
    return module.default;
  });
});

// Example route configuration
var routes = [{
  path: "egov-hrmsmodule/master/ServiceMaster",
  component: ServiceMasterSearch,
  needsAuthentication: true
}, {
  path: "egov-hrmsmodule/master/ServiceMasterAdd",
  component: ServiceMasterAdd,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-hrmsKmc/Routes/module-routes.js
// module id = 3530
// module chunks = 1137